import { render, staticRenderFns } from "./index.vue?vue&type=template&id=669df397&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=669df397&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('669df397')) {
      api.createRecord('669df397', component.options)
    } else {
      api.reload('669df397', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=669df397&lang=pug", function () {
      api.rerender('669df397', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/class/vipClassroom/academyTalksClassroomInfo/index.vue"
export default component.exports